<script setup lang="ts">
import { ecspPersonalComplianceProfileConfig } from '../../account/personal/complianceProfile/ecspComplianceProfile'
import AccountPanelPersonalComplianceProfileCategory from '../../account/personal/complianceProfile/AccountPanelPersonalComplianceProfileCategory.vue'
import { ref } from 'vue'

// currentForm is used to only open one form at a time and collapse the others
const currentForm = ref(null)
</script>

<template>
    <div class="overflow-hidden border border-gray-200 bg-white sm:col-span-1 sm:rounded-md">
        <ul role="list" class="ml-0 list-none space-y-2 divide-y divide-gray-200">
            <AccountPanelPersonalComplianceProfileCategory
                v-for="(form, key) in ecspPersonalComplianceProfileConfig"
                :key="key"
                v-model:current-form="currentForm"
                :form="form"
                :page-key="key"
                quick-edit />
        </ul>
    </div>
</template>

<style scoped></style>
